import * as React from "react";
import { Box, Button, FormControl, FormControlLabel, TextField, Typography, Checkbox, Select, MenuItem, InputLabel } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import Axios from 'axios';
import Alert from '../../components/alert/Alert';
import { useTheme } from "@mui/material";
import { tokens } from "../../theme";
import Backdrop from "../../components/Backdrop";
import IconButton from '@mui/material/IconButton';
import { FileUploadOutlined } from '@mui/icons-material';
import ClearIcon from '@mui/icons-material/Clear';
import HiddenPDF from '../hwQuestions/HiddenPDF';
import { Document, Page, pdfjs } from "react-pdf";
import { Autocomplete } from "@mui/material";
import { useTestCategories } from "../../utils/TestCategory";
import QuestionPreviewForTest from "../forms/QuestionPreviewForTest";
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormGroup from '@mui/material/FormGroup';
import Switch from '@mui/material/Switch';
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { getAuthHeader } from '../../utils/authToken';
import TestPreviewDialog from '../../components/TestPreviewDialog';


pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const AP_EXAM_FORMATS = [
    // Fully Digital — all FRQ typed on computer
    { label: 'AP African American Studies', group: 'Fully Digital' },
    { label: 'AP Art History', group: 'Fully Digital' },
    { label: 'AP Comparative Government and Politics', group: 'Fully Digital' },
    { label: 'AP Computer Science A', group: 'Fully Digital' },
    { label: 'AP Computer Science Principles', group: 'Fully Digital' },
    { label: 'AP English Language and Composition', group: 'Fully Digital' },
    { label: 'AP English Literature and Composition', group: 'Fully Digital' },
    { label: 'AP Environmental Science', group: 'Fully Digital' },
    { label: 'AP European History', group: 'Fully Digital' },
    { label: 'AP Human Geography', group: 'Fully Digital' },
    { label: 'AP Latin', group: 'Fully Digital' },
    { label: 'AP Psychology', group: 'Fully Digital' },
    { label: 'AP Seminar', group: 'Fully Digital' },
    { label: 'AP United States Government and Politics', group: 'Fully Digital' },
    { label: 'AP United States History', group: 'Fully Digital' },
    { label: 'AP World History: Modern', group: 'Fully Digital' },
    // Hybrid Digital — FRQ handwritten on paper
    { label: 'AP Biology', group: 'Hybrid Digital' },
    { label: 'AP Calculus AB', group: 'Hybrid Digital' },
    { label: 'AP Calculus BC', group: 'Hybrid Digital' },
    { label: 'AP Chemistry', group: 'Hybrid Digital' },
    { label: 'AP Macroeconomics', group: 'Hybrid Digital' },
    { label: 'AP Microeconomics', group: 'Hybrid Digital' },
    { label: 'AP Physics 1: Algebra-Based', group: 'Hybrid Digital' },
    { label: 'AP Physics 2: Algebra-Based', group: 'Hybrid Digital' },
    { label: 'AP Physics C: Electricity and Magnetism', group: 'Hybrid Digital' },
    { label: 'AP Physics C: Mechanics', group: 'Hybrid Digital' },
    { label: 'AP Precalculus', group: 'Hybrid Digital' },
    { label: 'AP Statistics', group: 'Hybrid Digital' },
];

const EditTest = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    // Fetch test categories from API
    const { categories: tests, loading: categoriesLoading } = useTestCategories();

    const [successAlertOpen, setSuccessAlertOpen] = React.useState(false);
    const [errorAlertOpen, setErrorAlertOpen] = React.useState(false);
    const [successAlertMessage, setSuccessAlertMessage] = React.useState("");
    const [errorAlertMessage, setErrorAlertMessage] = React.useState("");
    const isNonMobile = useMediaQuery("(min-width:600px)");

    const [backdropOpen, setBackdropOpen] = React.useState(false);
    const handleBackdropClose = () => {
        setBackdropOpen(false);
    };

    const [file, setFile] = React.useState(null);
    const [explanationFile, setExplanationFile] = React.useState(null);
    const [teacherFile, setTeacherFile] = React.useState(null);

    const [previewCardToggle, setPreviewCardToggle] = React.useState(false);
    const [previewDialogOpen, setPreviewDialogOpen] = React.useState(false);

    const [optionName, setOptionName] = React.useState(['A', 'B', 'C', 'D']);
    const [numChoices, setNumChoices] = React.useState(4);

    const [previewOptionName, setPreviewOptionName] = React.useState(['A', 'B', 'C', 'D']);
    const [previewNumChoices, setPreviewNumChoices] = React.useState(4);
    const [selectedSectionIndex, setSelectedSectionIndex] = React.useState(null);

    const [subject, setSubject] = React.useState(null);
    const [isSection, setIsSection] = React.useState(null);

    const [numQuestions, setNumQuestions] = React.useState('');

    const [sections, setSections] = React.useState([]);
    const [sample, setSample] = React.useState([]);

    const [testUpdated, setTestUpdated] = React.useState(false);

    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [sectionToDelete, setSectionToDelete] = React.useState(null);
    const [releaseGrades, setReleaseGrades] = React.useState(false);
    const [isFrqMode, setIsFrqMode] = React.useState(false);
    const [isSaMode, setIsSaMode] = React.useState(false);
    const [useActStyleChoices, setUseActStyleChoices] = React.useState(false);

    // FRQ rubric state (test-level)
    const [rubricFile, setRubricFile] = React.useState(null);
    const [selectedRubricId, setSelectedRubricId] = React.useState('');
    const [existingRubrics, setExistingRubrics] = React.useState([]);

    const testId = window.location.pathname.split('/')[window.location.pathname.split('/').length - 2];


    React.useEffect(() => {
        async function fetchTest() {
            await Axios.get(`${process.env.REACT_APP_URL}/api/v1/tests/${testId}`, {
                headers: {
                    Authorization: getAuthHeader(),
                },
            }).then((response) => {
                const test = response.data;
                // Find the matching category object from tests so subject has full structure (section, numChoices, etc.)
                const matchedCategory = tests.find(t => t.value === test.subject);
                setSubject(matchedCategory || test.subject);
                setIsSection({ value: test.has_section ? "With Section" : "No Section" });
                setReleaseGrades(test.release_grades || false);
                setIsFrqMode(test.has_frq || false);
                setUseActStyleChoices(test.has_special_choices || false);

                // Pre-populate rubric from any question that has one
                const allQs = test.has_section
                    ? (test.test_sections || []).flatMap(s => s.test_questions || [])
                    : (test.test_questions || []);
                const qWithRubric = allQs.find(q => q.rubric_id);
                if (qWithRubric?.rubric_id) {
                    setSelectedRubricId(String(qWithRubric.rubric_id));
                }

                if (test.has_section === true) {
                    const updatedSections = test.test_sections.map(section => ({
                        ...section,
                        numQuestions: section.test_questions.length
                    }));
                    setSections(updatedSections);
                } else {
                    setSample(test.test_questions);
                }
    
                // Set initial file state
                setFile({
                    file: null,
                    name: test.title,
                    url: test.file_url,
                    type: "application/pdf",
                    changed: false
                });

                // Set initial explanation file state
                setExplanationFile({
                    file: null,
                    name: test.explanations_file_url ? 'Existing Explanation PDF' : null,
                    url: test.explanations_file_url || null,
                    type: "application/pdf",
                    changed: false
                });

                // Set initial teacher file state
                setTeacherFile({
                    file: null,
                    name: test.teacher_file_url ? 'Existing Teacher PDF (Watermarked)' : null,
                    url: test.teacher_file_url || null,
                    type: "application/pdf",
                    changed: false
                });
            }).catch((error) => {
                console.log(error);
            });
        }
        fetchTest();

        // Fetch existing rubrics for dropdown
        Axios.get(`${process.env.REACT_APP_URL}/api/v1/test-rubrics`, {
            headers: { Authorization: getAuthHeader() },
        }).then(res => setExistingRubrics(res.data)).catch(() => {});
    }, [testUpdated]);

    // When categories finish loading, resolve a string subject to the full category object
    React.useEffect(() => {
        if (tests.length > 0 && typeof subject === 'string') {
            const matchedCategory = tests.find(t => t.value === subject);
            if (matchedCategory) {
                setSubject(matchedCategory);
            }
        }
    }, [tests, subject]);

    // Retroactively update existing sections/sample when ACT-style checkbox is toggled
    const actStyleInitializedRef = React.useRef(false);
    React.useEffect(() => {
        // Skip the initial load — sections already have the correct choices from the server
        if (!actStyleInitializedRef.current) {
            actStyleInitializedRef.current = true;
            return;
        }

        const getActChoices = (questionIndex, choiceCount) => {
            if (choiceCount === '4' || choiceCount === 4) {
                return questionIndex % 2 === 0 ? ['A', 'B', 'C', 'D'] : ['F', 'G', 'H', 'J'];
            } else if (choiceCount === '5' || choiceCount === 5) {
                return questionIndex % 2 === 0 ? ['A', 'B', 'C', 'D', 'E'] : ['F', 'G', 'H', 'J', 'K'];
            } else {
                const standardOptions = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K'];
                const evenOptions = ['F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q'];
                return questionIndex % 2 === 0 ? standardOptions.slice(0, choiceCount) : evenOptions.slice(0, choiceCount);
            }
        };

        const getStandardChoices = (choiceCount) => {
            const letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K'];
            return letters.slice(0, choiceCount);
        };

        const rebuildQuestions = (questions) => {
            return questions.map((question, qIndex) => {
                const opts = question.question_options || [];
                const choiceCount = opts.length;
                const newLabels = useActStyleChoices
                    ? getActChoices(qIndex, choiceCount)
                    : getStandardChoices(choiceCount);
                return {
                    ...question,
                    question_options: opts.map((o, idx) => ({
                        ...o,
                        option: newLabels[idx] || o.option,
                    })),
                };
            });
        };

        // Update all sections
        if (sections.length > 0) {
            const updatedSections = sections.map(section => ({
                ...section,
                test_questions: rebuildQuestions(section.test_questions || []),
            }));
            setSections(updatedSections);
        }

        // Update sample
        if (sample?.length > 0) {
            setSample(rebuildQuestions(sample));
        }
    }, [useActStyleChoices]);

    // Sync preview with selected section's/sample's choices when selection changes
    React.useEffect(() => {
        if (isSection?.value === "With Section" && selectedSectionIndex !== null && sections[selectedSectionIndex]) {
            const selectedSection = sections[selectedSectionIndex];
            const sectionChoices = selectedSection.test_questions?.[0]?.question_options || [];
            const newNumChoices = sectionChoices.length;

            if (newNumChoices > 0) {
                setPreviewNumChoices(newNumChoices);
                if (useActStyleChoices) {
                    const letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K'];
                    setPreviewOptionName(letters.slice(0, newNumChoices));
                } else {
                    setPreviewOptionName(sectionChoices.map(c => c.option));
                }
            }
        }

        // For "No Section" mode: sync preview with sample when selected
        if (isSection?.value === "No Section" && selectedSectionIndex === 0 && sample?.[0]) {
            const sampleChoices = sample[0]?.question_options || [];
            const newNumChoices = sampleChoices.length;

            if (newNumChoices > 0) {
                setPreviewNumChoices(newNumChoices);
                if (useActStyleChoices) {
                    const letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K'];
                    setPreviewOptionName(letters.slice(0, newNumChoices));
                } else {
                    setPreviewOptionName(sampleChoices.map(c => c.option));
                }
            }
        }
    }, [selectedSectionIndex, sample, sections, isSection, useActStyleChoices]);

    // Auto-select sample in "No Section" mode when sample exists
    React.useEffect(() => {
        if (isSection?.value === "No Section" && sample?.length > 0) {
            setSelectedSectionIndex(0);
        } else if (isSection?.value === "No Section" && (!sample || sample.length === 0)) {
            setSelectedSectionIndex(null);
        }
    }, [isSection, sample]);

    // Refs to access current values in preview→section sync without adding to dependencies
    const sampleRef = React.useRef(sample);
    const sectionsRef = React.useRef(sections);
    const isSectionRef = React.useRef(isSection);
    const selectedSectionIndexRef = React.useRef(selectedSectionIndex);
    const useActStyleChoicesRef2 = React.useRef(useActStyleChoices);

    React.useEffect(() => {
        sampleRef.current = sample;
        sectionsRef.current = sections;
        isSectionRef.current = isSection;
        selectedSectionIndexRef.current = selectedSectionIndex;
        useActStyleChoicesRef2.current = useActStyleChoices;
    }, [sample, sections, isSection, selectedSectionIndex, useActStyleChoices]);

    // Update selected section/sample when preview options change
    React.useEffect(() => {
        const isAct = useActStyleChoicesRef2.current;

        const getActChoices = (questionIndex, choiceCount) => {
            if (choiceCount === 4 || choiceCount === '4') {
                return questionIndex % 2 === 0 ? ['A', 'B', 'C', 'D'] : ['F', 'G', 'H', 'J'];
            } else if (choiceCount === 5 || choiceCount === '5') {
                return questionIndex % 2 === 0 ? ['A', 'B', 'C', 'D', 'E'] : ['F', 'G', 'H', 'J', 'K'];
            } else {
                const standardOptions = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K'];
                const evenOptions = ['F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q'];
                return questionIndex % 2 === 0 ? standardOptions.slice(0, choiceCount) : evenOptions.slice(0, choiceCount);
            }
        };

        const buildOptionsArray = (questionIndex) => {
            if (isAct) {
                const actLabels = getActChoices(questionIndex, previewOptionName.length);
                return actLabels.map((label) => ({ option: label }));
            }
            return previewOptionName.map((name, j) => ({
                option: name || String.fromCharCode(65 + j),
            }));
        };

        const currentSample = sampleRef.current;
        const currentSections = sectionsRef.current;
        const currentIsSection = isSectionRef.current;
        const currentSelectedSectionIndex = selectedSectionIndexRef.current;

        // For "No Section" mode: update sample when preview changes
        if (currentIsSection?.value === "No Section" && currentSample?.length > 0 && currentSelectedSectionIndex === 0) {
            const currentChoicesCount = currentSample[0]?.question_options?.length || 0;
            const hasCountChanged = currentChoicesCount !== previewOptionName.length;
            const hasNamesChanged = !isAct && currentSample.some((q) =>
                q.question_options?.some((o, oIdx) => o.option !== (previewOptionName[oIdx] || o.option))
            );

            if (hasCountChanged || hasNamesChanged) {
                const updatedQuestions = currentSample.map((question, qIdx) => ({
                    ...question,
                    question_options: buildOptionsArray(qIdx),
                }));
                setSample(updatedQuestions);
            }
        }

        // For "With Section" mode: update selected section when preview changes
        if (currentIsSection?.value === "With Section" && currentSelectedSectionIndex !== null && currentSections[currentSelectedSectionIndex]) {
            const selectedSection = currentSections[currentSelectedSectionIndex];
            const currentChoicesCount = selectedSection.test_questions?.[0]?.question_options?.length || 0;
            const hasCountChanged = currentChoicesCount !== previewOptionName.length;
            const hasNamesChanged = !isAct && selectedSection.test_questions?.some((q) =>
                q.question_options?.some((o, oIdx) => o.option !== (previewOptionName[oIdx] || o.option))
            );

            if (hasCountChanged || hasNamesChanged) {
                const updatedSections = currentSections.map((section, sIndex) => {
                    if (sIndex === currentSelectedSectionIndex) {
                        const updatedQuestions = section.test_questions.map((question, qIdx) => ({
                            ...question,
                            question_options: buildOptionsArray(qIdx),
                        }));
                        return { ...section, test_questions: updatedQuestions };
                    }
                    return section;
                });
                setSections(updatedSections);
            }
        }
    }, [previewOptionName]);

    const handleClickDialogOpen = (index) => {
        setSectionToDelete(index);
        setDialogOpen(true);
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
    };

    const handleDeleteSection = async () => {
        const updatedSections = sections.filter((_, index) => index !== sectionToDelete);
        const reIndexedSections = updatedSections.map((section, index) => {
            return {
                ...section,
                sectionNumber: index + 1,
            };
        });

        setSections(reIndexedSections);
        handleDialogClose();

        // Clear selection if the deleted section was selected, or adjust index if needed
        if (selectedSectionIndex === sectionToDelete) {
            setSelectedSectionIndex(null);
        } else if (selectedSectionIndex !== null && selectedSectionIndex > sectionToDelete) {
            setSelectedSectionIndex(selectedSectionIndex - 1);
        }

        if (reIndexedSections.length === 0) {
            setSelectedSectionIndex(null);
        }
    };
    

    const handleUpload = (event) => {
        setFile({
            file: event.target.files[0],
            name: event.target.files[0].name,
            url: URL.createObjectURL(event.target.files[0]),
            type: event.target.files[0].type,
            changed: true
        });
    };
    

    const handleFileRemove = (event) => {
        event.preventDefault();
        setFile(null);
    };

    const handleExplanationUpload = (event) => {
        const uploadedFile = event.target.files[0];
        if (uploadedFile && uploadedFile.type === "application/pdf") {
            setExplanationFile({
                file: uploadedFile,
                name: uploadedFile.name,
                url: URL.createObjectURL(uploadedFile),
                type: uploadedFile.type,
                changed: true
            });
        } else {
            setErrorAlertMessage("Please upload a PDF file for explanation");
            setErrorAlertOpen(true);
        }
    };

    const handleExplanationFileRemove = (event) => {
        event.preventDefault();
        setExplanationFile({
            file: null,
            name: null,
            url: null,
            type: null,
            changed: true
        });
    };

    const handleTeacherFileUpload = (event) => {
        const uploadedFile = event.target.files[0];
        if (uploadedFile && uploadedFile.type === "application/pdf") {
            setTeacherFile({
                file: uploadedFile,
                name: uploadedFile.name,
                url: URL.createObjectURL(uploadedFile),
                type: uploadedFile.type,
                changed: true
            });
        } else {
            setErrorAlertMessage("Please upload a PDF file");
            setErrorAlertOpen(true);
        }
    };

    const handleTeacherFileRemove = (event) => {
        event.preventDefault();
        setTeacherFile({
            file: null, name: null, url: null, type: null, changed: true
        });
    };

    // Toggle all FRQ parts to upload or text
    const handleToggleAllFrqUpload = (toUpload) => {
        const updateQuestions = (questions) => {
            return questions.map(q => {
                if (q.question_type !== 'frq') return q;
                if (toUpload) {
                    // Set question-level to upload if no parts, otherwise set each part to upload
                    if (q.frq_parts && q.frq_parts.length > 0) {
                        return { ...q, frq_parts: q.frq_parts.map(p => ({ ...p, part_type: 'upload' })) };
                    }
                    return { ...q, frq_type: 'upload' };
                } else {
                    // Revert to text
                    if (q.frq_parts && q.frq_parts.length > 0) {
                        return { ...q, frq_parts: q.frq_parts.map(p => ({ ...p, part_type: 'text' })) };
                    }
                    return { ...q, frq_type: 'saq' };
                }
            });
        };

        if (isSection?.value === "With Section") {
            setSections(prev => prev.map(s => ({
                ...s,
                test_questions: updateQuestions(s.test_questions || [])
            })));
        } else {
            setSample(prev => updateQuestions(prev));
        }
    };

    const handleSectionNameChange = (event, index) => {
        const updatedSections = sections.map((section, sIndex) => {
            if (sIndex === index) {
                return { ...section, section_name: event.target.value };
            }
            return section;
        });
        setSections(updatedSections);
    };

    const documentRender = () => {
        // Use devicePixelRatio to render crisp PDFs on high-DPI displays (Windows scaling, Retina, etc.)
        // Minimum scale of 2 ensures crisp rendering even at DPR 1
        const pixelRatio = Math.max(window.devicePixelRatio || 1, 2);

        return (
            <Document
                file={file}
                onContextMenu={(e) => e.preventDefault()}
                className="pdf-container"
            >
                <div>
                    <Page
                        pageNumber={1}
                        renderTextLayer={false}
                        renderAnnotationLayer={false}
                        scale={pixelRatio}
                    />
                </div>
            </Document>
        );
    };

    const handleCreateSection = () => {
        if (!numQuestions || numQuestions === '0') {
            setErrorAlertMessage("Please enter the number of questions");
            setErrorAlertOpen(true);
            return;
        }
        if (!isFrqMode && !isSaMode && (!numChoices || numChoices === '0')) {
            setErrorAlertMessage("Please enter the number of choices");
            setErrorAlertOpen(true);
            return;
        }

        if (numQuestions && (isFrqMode || isSaMode || numChoices)) {
            const newSection = {
                section_number: sections.length + 1,
                questions: [],
                numQuestions: numQuestions,
            };

            const createdQuestions = [];
            if (isSaMode) {
                for (let i = 0; i < numQuestions; i++) {
                    createdQuestions.push({
                        question_number: i + 1,
                        question_type: 'sa',
                        answer: '',
                        accepted_answers: [''],
                        max_points: 1,
                        question_options: [],
                    });
                }
            } else if (isFrqMode) {
                for (let i = 0; i < numQuestions; i++) {
                    createdQuestions.push({
                        question_number: i + 1,
                        question_type: 'frq',
                        frq_type: 'saq',
                        max_points: 3,
                        frq_parts: [{part_label: 'a', max_points: 1}, {part_label: 'b', max_points: 1}, {part_label: 'c', max_points: 1}],
                        choice_group: null,
                        rubric_id: null,
                        question_options: [],
                        answer: '',
                    });
                }
            } else if (useActStyleChoices) {
                // ACT-style alternating choices
                for (let i = 0; i < numQuestions; i++) {
                    let actOptions;
                    if (numChoices === '4' || numChoices === 4) {
                        actOptions = i % 2 === 0 ? ['A', 'B', 'C', 'D'] : ['F', 'G', 'H', 'J'];
                    } else if (numChoices === '5' || numChoices === 5) {
                        actOptions = i % 2 === 0 ? ['A', 'B', 'C', 'D', 'E'] : ['F', 'G', 'H', 'J', 'K'];
                    } else {
                        const standardOptions = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K'];
                        const evenOptions = ['F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q'];
                        actOptions = i % 2 === 0 ? standardOptions.slice(0, numChoices) : evenOptions.slice(0, numChoices);
                    }

                    const newQuestion = {
                        question_number: i + 1,
                        question_options: [],
                        answer: "",
                    };

                    for (let j = 0; j < numChoices; j++) {
                        newQuestion.question_options.push({
                            option: actOptions[j],
                        });
                    }

                    createdQuestions.push(newQuestion);
                }
            } else {
                for (let i = 0; i < numQuestions; i++) {
                    const newQuestion = {
                        question_number: i + 1,
                        question_options: [],
                        answer: "",
                    };
                    for (let j = 0; j < numChoices; j++) {
                        newQuestion.question_options.push({
                            option: optionName[j],
                        });
                    }
                    createdQuestions.push(newQuestion);
                }
            }

            newSection.test_questions = createdQuestions;
            newSection.numQuestions = numQuestions;

            setSections([...sections, newSection]);
        }
    };

    const handleCreateSample = () => {
        if (!numQuestions || numQuestions === '0') {
            setErrorAlertMessage("Please enter the number of questions");
            setErrorAlertOpen(true);
            return;
        }
        if (!isFrqMode && !isSaMode && (!numChoices || numChoices === '0')) {
            setErrorAlertMessage("Please enter the number of choices");
            setErrorAlertOpen(true);
            return;
        }

        if (numQuestions && (isFrqMode || isSaMode || numChoices)) {
            const newSample = {
                questions: [],
                numQuestions: numQuestions,
            };

            if (isSaMode) {
                for (let i = 0; i < numQuestions; i++) {
                    newSample.questions.push({
                        question_number: i + 1,
                        question_type: 'sa',
                        answer: '',
                        accepted_answers: [''],
                        max_points: 1,
                        question_options: [],
                    });
                }
            } else if (isFrqMode) {
                for (let i = 0; i < numQuestions; i++) {
                    newSample.questions.push({
                        question_number: i + 1,
                        question_type: 'frq',
                        frq_type: 'saq',
                        max_points: 3,
                        frq_parts: [{part_label: 'a', max_points: 1}, {part_label: 'b', max_points: 1}, {part_label: 'c', max_points: 1}],
                        choice_group: null,
                        rubric_id: null,
                        question_options: [],
                        answer: '',
                    });
                }
            } else if (useActStyleChoices) {
                // ACT-style alternating choices
                for (let i = 0; i < numQuestions; i++) {
                    let actOptions;
                    if (numChoices === '4' || numChoices === 4) {
                        actOptions = i % 2 === 0 ? ['A', 'B', 'C', 'D'] : ['F', 'G', 'H', 'J'];
                    } else if (numChoices === '5' || numChoices === 5) {
                        actOptions = i % 2 === 0 ? ['A', 'B', 'C', 'D', 'E'] : ['F', 'G', 'H', 'J', 'K'];
                    } else {
                        const standardOptions = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K'];
                        const evenOptions = ['F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q'];
                        actOptions = i % 2 === 0 ? standardOptions.slice(0, numChoices) : evenOptions.slice(0, numChoices);
                    }

                    const newQuestion = {
                        question_number: i + 1,
                        question_options: [],
                        answer: "",
                    };

                    for (let j = 0; j < numChoices; j++) {
                        newQuestion.question_options.push({
                            option: actOptions[j],
                        });
                    }

                    newSample.questions.push(newQuestion);
                }
            } else {
                for (let i = 0; i < numQuestions; i++) {
                    const newQuestion = {
                        question_number: i + 1,
                        question_options: [],
                        answer: "",
                    };

                    for (let j = 0; j < numChoices; j++) {
                        newQuestion.question_options.push({
                            option: optionName[j],
                        });
                    }

                    newSample.questions.push(newQuestion);
                }
            }
            setSample(newSample.questions);  // Stored as an array of questions
        }
    };

    const handleDeleteSample = () => {
        setSample([]);
        setSelectedSectionIndex(null);
    };

    const handleSectionAnswerChange = (sectionIndex, questionIndex, choice, isMultiSelect = false) => {
        const updatedSections = sections.map((section, sIndex) => {
            if (sIndex === sectionIndex) {
                const updatedQuestions = section.test_questions.map((question, qIndex) => {
                    if (qIndex === questionIndex) {
                        if (isMultiSelect) {
                            // Handle multi-select: toggle the choice in comma-separated string
                            const currentAnswers = question.answer ? question.answer.split(',') : [];
                            const choiceIndex = currentAnswers.indexOf(choice);
                            if (choiceIndex > -1) {
                                currentAnswers.splice(choiceIndex, 1);
                            } else {
                                currentAnswers.push(choice);
                            }
                            return { ...question, answer: currentAnswers.join(',') };
                        }
                        return { ...question, answer: choice };
                    }
                    return question;
                });
                return { ...section, test_questions: updatedQuestions };
            }
            return section;
        });
        setSections(updatedSections);
    };

    const handleSectionMultiSelectToggle = (sectionIndex, questionIndex) => {
        const updatedSections = sections.map((section, sIndex) => {
            if (sIndex === sectionIndex) {
                const updatedQuestions = section.test_questions.map((question, qIndex) => {
                    if (qIndex === questionIndex) {
                        const currentIsMultiSelect = question.is_multi_select || question.isMultiSelect || false;
                        return { ...question, isMultiSelect: !currentIsMultiSelect, is_multi_select: !currentIsMultiSelect, answer: '' };
                    }
                    return question;
                });
                return { ...section, test_questions: updatedQuestions };
            }
            return section;
        });
        setSections(updatedSections);
    };

    const handleSampleAnswerChange = (questionIndex, choice, isMultiSelect = false) => {
        const updatedQuestions = sample.map((question, qIndex) => {
            if (qIndex === questionIndex) {
                if (isMultiSelect) {
                    // Handle multi-select: toggle the choice in comma-separated string
                    const currentAnswers = question.answer ? question.answer.split(',') : [];
                    const choiceIndex = currentAnswers.indexOf(choice);
                    if (choiceIndex > -1) {
                        currentAnswers.splice(choiceIndex, 1);
                    } else {
                        currentAnswers.push(choice);
                    }
                    return { ...question, answer: currentAnswers.join(',') };
                }
                return { ...question, answer: choice };
            }
            return question;
        });

        setSample(updatedQuestions);
    };

    const handleQuestionTypeToggle = (sectionIndex, questionIndex) => {
        if (isSection?.value === "With Section") {
            const updatedSections = sections.map((section, sIdx) => {
                if (sIdx === sectionIndex) {
                    const updatedQuestions = section.test_questions.map((q, qIdx) => {
                        if (qIdx === questionIndex) {
                            const isMcq = !q.question_type || q.question_type === 'mcq';
                            if (isMcq) {
                                // Switch to FRQ
                                return { ...q, question_type: 'frq', frq_type: 'saq', max_points: 3, frq_parts: [{part_label: 'a', max_points: 1}, {part_label: 'b', max_points: 1}, {part_label: 'c', max_points: 1}], answer: '', rubric_id: null };
                            } else {
                                // Switch back to MCQ
                                return { ...q, question_type: 'mcq', frq_type: null, max_points: null, frq_parts: null, rubric_id: null, choice_group: null, answer: '', isMultiSelect: false, is_multi_select: false, num_choices: 4, question_options: [{option:'A'},{option:'B'},{option:'C'},{option:'D'}] };
                            }
                        }
                        return q;
                    });
                    return { ...section, test_questions: updatedQuestions };
                }
                return section;
            });
            setSections(updatedSections);
        } else {
            // No section mode — sample is an array of questions
            const updatedQuestions = sample.map((q, qIdx) => {
                if (qIdx === questionIndex) {
                    const isMcq = !q.question_type || q.question_type === 'mcq';
                    if (isMcq) {
                        return { ...q, question_type: 'frq', frq_type: 'saq', max_points: 3, frq_parts: [{part_label: 'a', max_points: 1}, {part_label: 'b', max_points: 1}, {part_label: 'c', max_points: 1}], answer: '', rubric_id: null };
                    } else {
                        return { ...q, question_type: 'mcq', frq_type: null, max_points: null, frq_parts: null, rubric_id: null, choice_group: null, answer: '', isMultiSelect: false, is_multi_select: false, num_choices: 4, question_options: [{option:'A'},{option:'B'},{option:'C'},{option:'D'}] };
                    }
                }
                return q;
            });
            setSample(updatedQuestions);
        }
    };

    const handleQuestionTypeChange = (sectionIndex, questionIndex, newType) => {
        const buildQuestion = (q) => {
            if (newType === 'frq') {
                return { ...q, question_type: 'frq', frq_type: 'saq', max_points: 3, frq_parts: [{part_label: 'a', max_points: 1}, {part_label: 'b', max_points: 1}, {part_label: 'c', max_points: 1}], answer: '', accepted_answers: null, rubric_id: null };
            } else if (newType === 'sa') {
                return { ...q, question_type: 'sa', frq_type: null, max_points: 1, frq_parts: null, rubric_id: null, choice_group: null, answer: '', accepted_answers: [''], isMultiSelect: false, is_multi_select: false, question_options: [] };
            } else {
                return { ...q, question_type: 'mcq', frq_type: null, max_points: null, frq_parts: null, rubric_id: null, choice_group: null, answer: '', accepted_answers: null, isMultiSelect: false, is_multi_select: false, num_choices: 4, question_options: [{option:'A'},{option:'B'},{option:'C'},{option:'D'}] };
            }
        };

        if (isSection?.value === "With Section") {
            const updatedSections = sections.map((section, sIdx) => {
                if (sIdx === sectionIndex) {
                    const updatedQuestions = section.test_questions.map((q, qIdx) => {
                        if (qIdx === questionIndex) return buildQuestion(q);
                        return q;
                    });
                    return { ...section, test_questions: updatedQuestions };
                }
                return section;
            });
            setSections(updatedSections);
        } else {
            const updatedQuestions = sample.map((q, qIdx) => {
                if (qIdx === questionIndex) return buildQuestion(q);
                return q;
            });
            setSample(updatedQuestions);
        }
    };

    const updateQuestionFrqField = (sectionIndex, questionIndex, field, value) => {
        if (isSection?.value === "With Section") {
            const updatedSections = sections.map((section, sIdx) => {
                if (sIdx === sectionIndex) {
                    const updatedQuestions = section.test_questions.map((q, qIdx) => {
                        if (qIdx === questionIndex) {
                            const updated = { ...q, [field]: value };
                            // Auto-set max_points and frq_parts when frq_type changes
                            if (field === 'frq_type') {
                                if (value === 'saq') {
                                    updated.max_points = 3;
                                    updated.frq_parts = [{part_label: 'a', max_points: 1}, {part_label: 'b', max_points: 1}, {part_label: 'c', max_points: 1}];
                                } else if (value === 'dbq') {
                                    updated.max_points = 7;
                                    updated.frq_parts = null;
                                } else if (value === 'leq') {
                                    updated.max_points = 6;
                                    updated.frq_parts = null;
                                }
                            }
                            return updated;
                        }
                        return q;
                    });
                    return { ...section, test_questions: updatedQuestions };
                }
                return section;
            });
            setSections(updatedSections);
        } else {
            const updatedQuestions = sample.map((q, qIdx) => {
                if (qIdx === questionIndex) {
                    const updated = { ...q, [field]: value };
                    if (field === 'frq_type') {
                        if (value === 'saq') {
                            updated.max_points = 3;
                            updated.frq_parts = [{part_label: 'a', max_points: 1}, {part_label: 'b', max_points: 1}, {part_label: 'c', max_points: 1}];
                        } else if (value === 'dbq') {
                            updated.max_points = 7;
                            updated.frq_parts = null;
                        } else if (value === 'leq') {
                            updated.max_points = 6;
                            updated.frq_parts = null;
                        }
                    }
                    return updated;
                }
                return q;
            });
            setSample(updatedQuestions);
        }
    };

    const updateFrqParts = (sectionIndex, questionIndex, newParts) => {
        const totalPoints = newParts.reduce((sum, p) => sum + (p.max_points || 0), 0);
        if (isSection?.value === "With Section") {
            const updatedSections = sections.map((section, sIdx) => {
                if (sIdx === sectionIndex) {
                    const updatedQuestions = (section.test_questions || []).map((q, qIdx) => {
                        if (qIdx === questionIndex) return { ...q, frq_parts: newParts, max_points: totalPoints };
                        return q;
                    });
                    return { ...section, test_questions: updatedQuestions };
                }
                return section;
            });
            setSections(updatedSections);
        } else {
            const updatedQuestions = (sample || []).map((q, qIdx) => {
                if (qIdx === questionIndex) return { ...q, frq_parts: newParts, max_points: totalPoints };
                return q;
            });
            setSample(updatedQuestions);
        }
    };

    const handleSampleMultiSelectToggle = (questionIndex) => {
        const updatedQuestions = sample.map((question, qIndex) => {
            if (qIndex === questionIndex) {
                const currentIsMultiSelect = question.is_multi_select || question.isMultiSelect || false;
                return { ...question, isMultiSelect: !currentIsMultiSelect, is_multi_select: !currentIsMultiSelect, answer: '' };
            }
            return question;
        });
        setSample(updatedQuestions);
    };

    const handleAddQuestion = async (sectionIndex, questionIndex, qOptions) => {

        const optionNames = qOptions.map(option => option.option);

        const newQuestion = {
            question_number: questionIndex + 1,
            question_options: optionNames.map(option => ({ option })),
            answer: ""
        };

        const updatedSections = sections.map((section, sIndex) => {
            if (sIndex === sectionIndex) {
                const updatedQuestions = [...section.test_questions];
                updatedQuestions.splice(questionIndex + 1, 0, newQuestion);

                // Reorder question numbers
                const reorderedQuestions = updatedQuestions.map((question, index) => ({
                    ...question,
                    question_number: index + 1
                }));

                return { ...section, test_questions: reorderedQuestions };
            }
            return section;
        });
        setSections(updatedSections);
    }
    

    const handleDeleteQuestion = async (sectionIndex, questionIndex) => {
        const updatedSections = sections.map((section, sIndex) => {
            if (sIndex === sectionIndex) {
                if (section.test_questions.length <= 1) {
                    setErrorAlertMessage("At least one problem is needed in the section.");
                    setErrorAlertOpen(true);
                    return section;
                }
                const updatedQuestions = section.test_questions.filter((_, qIndex) => qIndex !== questionIndex);
    
                // Reorder question numbers
                const reorderedQuestions = updatedQuestions.map((question, index) => ({
                    ...question,
                    question_number: index + 1
                }));
    
                return { ...section, test_questions: reorderedQuestions };
            }
            return section;
        });
        setSections(updatedSections);
    };
    
    
    const handleAddQuestionForNoSection = async (questionIndex, qOptions) => {

        const optionNames = qOptions.map(option => option.option);

        const newQuestion = {
            question_number: questionIndex + 1,
            question_options: optionNames.map(option => ({ option })),
            answer: ""
        };

        const updatedQuestions = [...sample];
        updatedQuestions.splice(questionIndex + 1, 0, newQuestion);

        // Reorder question numbers
        const reorderedQuestions = updatedQuestions.map((question, index) => ({
            ...question,
            question_number: index + 1
        }));
        setSample(reorderedQuestions);
   
    };
    
    const handleDeleteQuestionForNoSection = async (questionIndex) => {
        if (sample.length <= 1) {
            setErrorAlertMessage("At least one problem is needed in the test.");
            setErrorAlertOpen(true);
            return;
        }
        const updatedQuestions = sample.filter((_, qIndex) => qIndex !== questionIndex);
        // Reorder question numbers
        const reorderedQuestions = updatedQuestions.map((question, index) => ({
            ...question,
            question_number: index + 1
        }));
        setSample(reorderedQuestions);
    };
    

    const handleFormSubmit = async (values) => {
        setBackdropOpen(true);
    
        if (isSection && isSection.value === "With Section" && sections.length === 0) {
            setErrorAlertOpen(true);
            setErrorAlertMessage("At least one section is necessary");
            setBackdropOpen(false);
            return;
        }        
    
        if (isSection && isSection.value === "No Section" && sample.length === 0) {
            setErrorAlertOpen(true);
            setErrorAlertMessage("At least one sample is necessary");
            setBackdropOpen(false);
            return;
        }
    
        if (!file || (file.changed && file.type !== "application/pdf")) {
            setErrorAlertOpen(true);
            setErrorAlertMessage("Please upload a valid pdf file");
            setBackdropOpen(false);
            return;
        }
    
        if (!subject) {
            setErrorAlertOpen(true);
            setErrorAlertMessage("Please select subjects");
            setBackdropOpen(false);
            return;
        }
    
        if (!isSection) {
            setErrorAlertOpen(true);
            setErrorAlertMessage("Please select with section or no section");
            setBackdropOpen(false);
            return;
        }
    
        const formData = new FormData();

        if (file && file.changed) {
            formData.append('file', file.file);
        }

        // Handle explanation file
        if (explanationFile && explanationFile.changed) {
            if (explanationFile.file) {
                formData.append('explanationFile', explanationFile.file);
            } else {
                formData.append('removeExplanationFile', 'true');
            }
        }

        // Handle teacher (watermarked) file
        if (teacherFile && teacherFile.changed) {
            if (teacherFile.file) {
                formData.append('teacherFile', teacherFile.file);
            } else {
                formData.append('removeTeacherFile', 'true');
            }
        }

        // if subject has been changed, send the subject.value
        if (subject && subject.value) {
            formData.append('subject', subject.value);
        }
        else {
            formData.append('subject', subject);
        }
        formData.append('isSection', isSection ? isSection.value : '');
        formData.append('release_grades', releaseGrades.toString());
        formData.append('has_special_choices', useActStyleChoices.toString());

        // Rubric: either upload new file or reference existing
        if (rubricFile) {
            formData.append('rubricFile', rubricFile);
        } else if (selectedRubricId) {
            formData.append('rubricId', selectedRubricId.toString());
        }

        if (isSection.value === "With Section") {
            formData.append('sections', JSON.stringify(sections));
        } else {
            formData.append('sample', JSON.stringify(sample));
        }
    
        await Axios.put(`${process.env.REACT_APP_URL}/api/v1/tests/${testId}/editTest`, formData, {
            headers: {
                Authorization: getAuthHeader(),
                'Content-Type': 'multipart/form-data'
            }
        }).then((response) => {
            setSuccessAlertMessage(response.data.message);
            setSuccessAlertOpen(true);
            handleBackdropClose();
            setTestUpdated(true);
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        }).catch((error) => {
            console.log(error);
            setErrorAlertMessage(error.response?.data?.message || "Something went wrong");
            setErrorAlertOpen(true);
            handleBackdropClose();
        });
    };

    const handleDragEnd = async (result) => {
        const { destination, source } = result;

        if (!destination) {
            return;
        }

        if (destination.droppableId === source.droppableId && destination.index === source.index) {
            return;
        }

        const currentSections = Array.from(sections);
        const [removed] = currentSections.splice(source.index, 1);
        currentSections.splice(destination.index, 0, removed);

        const reorderedSections = currentSections.map((section, index) => ({
            ...section,
            section_number: index + 1
        }));

        setSections(reorderedSections);

        // Update selected section index if needed
        if (selectedSectionIndex !== null) {
            if (selectedSectionIndex === source.index) {
                setSelectedSectionIndex(destination.index);
            } else if (source.index < selectedSectionIndex && destination.index >= selectedSectionIndex) {
                setSelectedSectionIndex(selectedSectionIndex - 1);
            } else if (source.index > selectedSectionIndex && destination.index <= selectedSectionIndex) {
                setSelectedSectionIndex(selectedSectionIndex + 1);
            }
        }
    };

    React.useEffect(() => {
        localStorage.setItem('selectedMenu', 'Edit Test');
    }, []);

    return (
        <Box m="20px" marginX={3} marginY={3}>
            <Header title="Edit Test" subtitle="A ONE Institute" />
            <Box 
                sx={{ 
                    flexBasis: "50%", 
                    display: "flex", 
                    flexDirection: "column", 
                    gap: "10px", 
                    typography: 'subtitle2',
                    mb: 5
                }}
            >
                <Typography variant="h3" fontWeight="bold">Instructions:</Typography>
                <Typography>1. You would see the structure of the test you selected when it was created.</Typography>
                <Typography>2. You can change the answer, add a section, delete a section, add a question, delete a question, change the file, and modify the category freely.</Typography>
                <Typography>3. If you click the '+' button next to the question number, it will create a new question right next to the current question.</Typography>
                <Typography>4. If you click the '-' button next to the question number, it will remove the selected question.</Typography>
                <Typography>5. If you edit a test with sections, you can also change the order of the sections by dragging and dropping.</Typography>
                <Typography>6. Make sure to click 'Update the Test' at the bottom when you are done; otherwise, your changes will not be saved.</Typography>  
            </Box>
            <Formik
                onSubmit={handleFormSubmit}
                initialValues={initialValues}
                validationSchema={checkoutSchema}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                }) => (
                <form onSubmit={handleSubmit}>
                    <Box
                        padding={4}
                        boxShadow={3}
                        borderRadius={3}
                        m={1}
                        bgcolor={colors.primary[600]}
                    >
                        <Typography
                            variant="h4"
                            fontWeight="bold"
                            mb={3}
                        >
                            Test Information
                        </Typography>
                        <Box
                            display="grid"
                            gap="30px"
                            gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                            sx={{
                                "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                            }}
                        >
                            <Box
                                display="flex"
                                sx={{ gridColumn: "span 4" }}
                            >
                                <Box display="flex" alignItems="center">
                                    <Typography variant="h6" fontWeight="bold" color={colors.primary[450]}>
                                        Upload Files
                                    </Typography>
                                    <IconButton component="label">
                                        <FileUploadOutlined />
                                        <input
                                            multiple={false}
                                            style={{display:"none"}}
                                            type="file"
                                            hidden
                                            onChange={handleUpload}
                                            name="[licenseFile]"
                                        />
                                    </IconButton>
                                </Box>
                                {file && (
                                    <Box
                                        display="flex"
                                        flexDirection="column"
                                    >
                                        <Box display="flex" alignItems="center">
                                            <Typography variant="body1" color={colors.primary[450]}>
                                                {file.name}
                                            </Typography>
                                            {/* <a href={file.url} target="_blank" rel="noopener noreferrer">View File</a> */}
                                            <IconButton onClick={(e) => handleFileRemove(e)}>
                                                <ClearIcon />
                                            </IconButton>
                                        </Box>
                                    </Box>
                                )}
                            </Box>
                            {/* Explanation PDF Upload (Optional) */}
                            <Box
                                display="flex"
                                sx={{ gridColumn: "span 4", mt: 1 }}
                            >
                                <Box display="flex" alignItems="center">
                                    <Typography variant="h6" fontWeight="bold" color={colors.primary[450]}>
                                        Upload Explanation PDF (Optional)
                                    </Typography>
                                    <IconButton component="label">
                                        <FileUploadOutlined />
                                        <input
                                            multiple={false}
                                            style={{display:"none"}}
                                            type="file"
                                            hidden
                                            accept="application/pdf"
                                            onChange={handleExplanationUpload}
                                        />
                                    </IconButton>
                                </Box>
                                {explanationFile && explanationFile.name && (
                                    <Box display="flex" alignItems="center">
                                        <Typography variant="body1" color={colors.primary[450]}>
                                            {explanationFile.name}
                                        </Typography>
                                        <IconButton onClick={handleExplanationFileRemove}>
                                            <ClearIcon />
                                        </IconButton>
                                    </Box>
                                )}
                            </Box>
                            {/* Teacher PDF Upload (Watermarked) */}
                            <Box
                                display="flex"
                                sx={{ gridColumn: "span 4", mt: 1 }}
                            >
                                <Box display="flex" alignItems="center">
                                    <Typography variant="h6" fontWeight="bold" color={colors.primary[450]}>
                                        Upload Teacher PDF — Watermarked (Optional)
                                    </Typography>
                                    <IconButton component="label">
                                        <FileUploadOutlined />
                                        <input
                                            multiple={false}
                                            style={{display:"none"}}
                                            type="file"
                                            hidden
                                            accept="application/pdf"
                                            onChange={handleTeacherFileUpload}
                                        />
                                    </IconButton>
                                </Box>
                                {teacherFile && teacherFile.name && (
                                    <Box display="flex" alignItems="center">
                                        <Typography variant="body1" color={colors.primary[450]}>
                                            {teacherFile.name}
                                        </Typography>
                                        <IconButton onClick={handleTeacherFileRemove}>
                                            <ClearIcon />
                                        </IconButton>
                                    </Box>
                                )}
                            </Box>
                            {/* Mark all FRQ as Upload toggle */}
                            {isFrqMode && (
                                <Box display="flex" alignItems="center" sx={{ gridColumn: "span 4", mt: 1, gap: 1, flexWrap: 'wrap' }}>
                                    <Typography variant="h6" fontWeight="bold" color={colors.primary[450]}>
                                        All FRQ as Image Upload
                                    </Typography>
                                    <Button size="small" variant="outlined" color="info" onClick={() => handleToggleAllFrqUpload(true)}>
                                        All IMG
                                    </Button>
                                    <Button size="small" variant="outlined" color="warning" onClick={() => handleToggleAllFrqUpload(false)}>
                                        All TXT
                                    </Button>
                                    <Autocomplete
                                        size="small"
                                        sx={{ minWidth: 280 }}
                                        options={AP_EXAM_FORMATS}
                                        groupBy={(option) => option.group}
                                        getOptionLabel={(option) => option.label}
                                        onChange={(e, val) => {
                                            if (val) handleToggleAllFrqUpload(val.group === 'Hybrid Digital');
                                        }}
                                        renderInput={(params) => <TextField {...params} label="AP Exam Format" placeholder="Search AP exam..." />}
                                    />
                                </Box>
                            )}
                            {/* Rubric PDF Upload (Optional) */}
                            <Box
                                display="flex"
                                sx={{ gridColumn: "span 4", mt: 1 }}
                            >
                                <Box display="flex" alignItems="center">
                                    <Typography variant="h6" fontWeight="bold" color={colors.primary[450]}>
                                        Upload Rubric PDF (Optional)
                                    </Typography>
                                    <IconButton component="label">
                                        <FileUploadOutlined />
                                        <input
                                            multiple={false}
                                            style={{display:"none"}}
                                            type="file"
                                            hidden
                                            accept="application/pdf"
                                            onChange={(e) => {
                                                const f = e.target.files[0];
                                                if (f && f.type === "application/pdf") {
                                                    setRubricFile(f);
                                                    setSelectedRubricId('');
                                                } else {
                                                    setErrorAlertMessage("Please upload a PDF file");
                                                    setErrorAlertOpen(true);
                                                }
                                            }}
                                        />
                                    </IconButton>
                                </Box>
                                {rubricFile && (
                                    <Box display="flex" alignItems="center">
                                        <Typography variant="body1" color={colors.primary[450]}>
                                            {rubricFile.name}
                                        </Typography>
                                        <IconButton onClick={(e) => { e.preventDefault(); setRubricFile(null); }}>
                                            <ClearIcon />
                                        </IconButton>
                                    </Box>
                                )}
                                {!rubricFile && (
                                    <FormControl size="small" sx={{ minWidth: 250, ml: 2 }}>
                                        <InputLabel>or select existing rubric</InputLabel>
                                        <Select
                                            value={selectedRubricId}
                                            label="or select existing rubric"
                                            onChange={(e) => setSelectedRubricId(e.target.value)}
                                        >
                                            <MenuItem value="">None</MenuItem>
                                            {existingRubrics.map(r => (
                                                <MenuItem key={r.id} value={String(r.id)}>{r.name}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                )}
                            </Box>
                            <Autocomplete
                                id="free-solo-demo"
                                options={tests}
                                sx={{ gridColumn: "span 1" }}
                                value={subject ? subject : null} // Set the default value
                                renderInput={(params) => <TextField {...params} label="Subject" />}
                                isOptionEqualToValue={(option, value) => {
                                    return option.value === value.value;
                                }}
                                onChange={(event, newValue) => {
                                    if (newValue !== null && newValue !== undefined) {
                                        setSubject(newValue);                                                                                
                                    } else {
                                        setSubject(null);
                                        setIsSection(null);
                                        setSections([]); // Reset sections when subject changes
                                        setFile(null); // Reset file when subject changes
                                    }
                                }}
                            />
                            {subject !== null && subject.section !== undefined && (
                                <Autocomplete
                                    id="free-solo-demo"
                                    options={subject.section}
                                    sx={{ gridColumn: "span 1" }}
                                    value={isSection.value ? isSection.value : null} // Set the default value
                                    renderInput={(params) => <TextField {...params} label="Section" />}
                                    isOptionEqualToValue={(option, value) => {
                                        return option.value === value.value;
                                    }}
                                    onChange={(event, newValue) => {
                                        if (newValue !== null && newValue !== undefined) {
                                            setIsSection(newValue);
                                        } else {
                                            setIsSection(null);
                                        }
                                    }}
                                />
                            )}
                            <Box sx={{ gridColumn: "span 4" }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={releaseGrades}
                                            onChange={async (e) => {
                                                const newValue = e.target.checked;
                                                setReleaseGrades(newValue);
                                                try {
                                                    await Axios.patch(
                                                        `${process.env.REACT_APP_URL}/api/v1/tests/${testId}/release-grades`,
                                                        { release_grades: newValue },
                                                        { headers: { Authorization: getAuthHeader(), 'Content-Type': 'application/json' } }
                                                    );
                                                    setSuccessAlertMessage(newValue ? "Grades released to students" : "Grades hidden from students");
                                                    setSuccessAlertOpen(true);
                                                } catch (err) {
                                                    setReleaseGrades(!newValue);
                                                    setErrorAlertMessage("Failed to update release grades");
                                                    setErrorAlertOpen(true);
                                                }
                                            }}
                                            sx={{
                                                color: colors.blueAccent[400],
                                                '&.Mui-checked': {
                                                    color: colors.blueAccent[400],
                                                },
                                            }}
                                        />
                                    }
                                    label="Release grades to students (students can view their scores)"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={isSaMode}
                                            onChange={(e) => { setIsSaMode(e.target.checked); if (e.target.checked) setIsFrqMode(false); }}
                                            sx={{
                                                color: colors.blueAccent[400],
                                                '&.Mui-checked': {
                                                    color: colors.blueAccent[400],
                                                },
                                            }}
                                        />
                                    }
                                    label="SA (Short Answer — text match grading)"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={isFrqMode}
                                            onChange={(e) => { setIsFrqMode(e.target.checked); if (e.target.checked) setIsSaMode(false); }}
                                            sx={{
                                                color: colors.blueAccent[400],
                                                '&.Mui-checked': {
                                                    color: colors.blueAccent[400],
                                                },
                                            }}
                                        />
                                    }
                                    label="FRQ (Free Response Questions)"
                                />
                                {!isFrqMode && !isSaMode && (
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={useActStyleChoices}
                                            onChange={(e) => setUseActStyleChoices(e.target.checked)}
                                            sx={{
                                                color: colors.blueAccent[400],
                                                '&.Mui-checked': {
                                                    color: colors.blueAccent[400],
                                                },
                                            }}
                                        />
                                    }
                                    label="ACT-style alternating choices (A,B,C,D for odd / F,G,H,J for even questions)"
                                />
                                )}
                            </Box>
                            {(isSection && isSection.value) && (
                                <Box sx={{ gridColumn: "span 4", display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                    <TextField
                                        sx={{ width: "80%"}}
                                        variant="filled"
                                        type="number"
                                        label="Number of Questions"
                                        onBlur={handleBlur}
                                        onChange={(e) => setNumQuestions(e.target.value)}
                                        InputProps={{
                                            inputProps: { min: 0 }
                                        }}
                                        value={numQuestions}
                                        name="numQuestions"
                                        error={!!touched.questions && !!errors.questions}
                                        helperText={touched.questions && errors.questions}
                                    />
                                    {!isFrqMode && !isSaMode && (
                                    <TextField
                                        sx={{ width: "80%"}}
                                        variant="filled"
                                        type="number"
                                        label="Number of Choices"
                                        onBlur={handleBlur}
                                        onChange={(e) => setNumChoices(e.target.value)}
                                        InputProps={{
                                            inputProps: { min: 0 }
                                        }}
                                        value={numChoices}
                                        name="numChoices"
                                        error={!!touched.choices && !!errors.choices}
                                        helperText={touched.choices && errors.choices}
                                    />
                                    )}

                            {isSection.value === "With Section" ? (
                                <Button
                                    sx={{ width: "80%" }}
                                    color="secondary"
                                    variant="contained"
                                    onClick={handleCreateSection}
                                >
                                    Create Section
                                </Button>
                            ) : (
                                sample.length === 0 ? (
                                    <Button
                                        sx={{ width: "80%" }}
                                        color="secondary"
                                        variant="contained"
                                        onClick={handleCreateSample}
                                    >
                                        Create Sample
                                    </Button>
                                ) : (
                                    <Box sx={{ display: "flex", flexDirection: "column", gap: "10px", mt: 2, p: 2, bgcolor: colors.primary[600], borderRadius: 2, boxShadow: 3 }}>
                                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                            <Typography variant="h6">Sample</Typography>
                                            <ClearIcon
                                                fontSize='small'
                                                color='error'
                                                sx={{ cursor: "pointer", alignSelf: "flex-start" }}
                                                onClick={handleDeleteSample}
                                            />
                                        </Box>
                                        <ul>
                                            {sample.map((question, qIndex) => (
                                                <li key={qIndex}>
                                                    <Box sx={{ display: "flex", alignItems: "center"}}>
                                                        <Typography variant="body1">Q{question.question_number}</Typography>
                                                        <AddIcon
                                                            fontSize='small'
                                                            color='primary'
                                                            sx={{ cursor: "pointer", ml: 1, mr: 1 }}
                                                            onClick={() => handleAddQuestionForNoSection(qIndex, question.question_options)}
                                                        />
                                                        <RemoveIcon
                                                            fontSize='small'
                                                            color='primary'
                                                            sx={{ cursor: "pointer", mr: 1 }}
                                                            onClick={() => handleDeleteQuestionForNoSection(qIndex)}
                                                        />
                                                        <FormControl size="small" sx={{ minWidth: 80, ml: 1 }}>
                                                            <Select
                                                                value={question.question_type || 'mcq'}
                                                                onChange={(e) => handleQuestionTypeChange(null, qIndex, e.target.value)}
                                                                sx={{ fontSize: '0.75rem', height: 28 }}
                                                            >
                                                                <MenuItem value="mcq">MCQ</MenuItem>
                                                                <MenuItem value="sa">SA</MenuItem>
                                                                <MenuItem value="frq">FRQ</MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                        {(!question.question_type || question.question_type === 'mcq') && (
                                                            <FormControlLabel
                                                                control={
                                                                    <Switch
                                                                        size="small"
                                                                        checked={question.is_multi_select || question.isMultiSelect || false}
                                                                        onChange={() => handleSampleMultiSelectToggle(qIndex)}
                                                                    />
                                                                }
                                                                label={<Typography variant="caption">Multi</Typography>}
                                                            />
                                                        )}
                                                    </Box>
                                                    {question.question_type === 'sa' ? (
                                                        <Box sx={{ ml: 2, p: 1, border: '1px dashed #4cceac', borderRadius: 1 }}>
                                                            <Typography variant="caption" color="text.secondary">Accepted Answers (first = display answer):</Typography>
                                                            {(question.accepted_answers || ['']).map((alt, aIdx) => (
                                                                <Box key={aIdx} sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
                                                                    <Typography variant="caption" sx={{ minWidth: 16, color: aIdx === 0 ? colors.greenAccent[400] : colors.grey[500] }}>{aIdx + 1}.</Typography>
                                                                    <TextField size="small" value={alt}
                                                                        placeholder={aIdx === 0 ? 'Primary answer' : `Alternate ${aIdx}`}
                                                                        onChange={(e) => {
                                                                            const newAlts = [...(question.accepted_answers || [''])];
                                                                            newAlts[aIdx] = e.target.value;
                                                                            const updatedQuestions = sample.map((q, qi) => qi === qIndex ? { ...q, accepted_answers: newAlts, answer: newAlts[0] || '' } : q);
                                                                            setSample(updatedQuestions);
                                                                        }}
                                                                        sx={{ flex: 1 }}
                                                                    />
                                                                    {(question.accepted_answers || ['']).length > 1 && (
                                                                        <IconButton size="small" onClick={() => {
                                                                            const newAlts = (question.accepted_answers || ['']).filter((_, i) => i !== aIdx);
                                                                            const updatedQuestions = sample.map((q, qi) => qi === qIndex ? { ...q, accepted_answers: newAlts, answer: newAlts[0] || '' } : q);
                                                                            setSample(updatedQuestions);
                                                                        }}>
                                                                            <ClearIcon fontSize="small" />
                                                                        </IconButton>
                                                                    )}
                                                                </Box>
                                                            ))}
                                                            <Button size="small" onClick={() => {
                                                                const newAlts = [...(question.accepted_answers || ['']), ''];
                                                                const updatedQuestions = sample.map((q, qi) => qi === qIndex ? { ...q, accepted_answers: newAlts } : q);
                                                                setSample(updatedQuestions);
                                                            }}>+ Add</Button>
                                                        </Box>
                                                    ) : question.question_type === 'frq' ? (
                                                        <Box sx={{ ml: 2, p: 1, border: '1px dashed #999', borderRadius: 1 }}>
                                                            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 1 }}>
                                                                <FormControl size="small" sx={{ minWidth: 120 }}>
                                                                    <InputLabel>FRQ Type</InputLabel>
                                                                    <Select value={question.frq_type || 'saq'} label="FRQ Type"
                                                                        onChange={(e) => updateQuestionFrqField(null, qIndex, 'frq_type', e.target.value)}>
                                                                        <MenuItem value="saq">SAQ</MenuItem>
                                                                        <MenuItem value="dbq">DBQ</MenuItem>
                                                                        <MenuItem value="leq">LEQ</MenuItem>
                                                                        <MenuItem value="upload">Upload</MenuItem>
                                                                    </Select>
                                                                </FormControl>
                                                                {(() => {
                                                                    const partsSum = question.frq_type === 'saq' && question.frq_parts
                                                                        ? question.frq_parts.reduce((s, p) => s + (p.max_points || 0), 0) : null;
                                                                    const mismatch = partsSum !== null && question.max_points !== partsSum;
                                                                    return (
                                                                        <TextField size="small" label="Max Points" type="number"
                                                                            value={question.max_points || ''} sx={{ width: 100 }}
                                                                            error={mismatch}
                                                                            helperText={mismatch ? `Parts sum: ${partsSum}` : ''}
                                                                            onChange={(e) => updateQuestionFrqField(null, qIndex, 'max_points', parseInt(e.target.value) || 0)} />
                                                                    );
                                                                })()}
                                                                <TextField size="small" label="Choice Group" type="number"
                                                                    value={question.choice_group || ''} sx={{ width: 120 }}
                                                                    onChange={(e) => updateQuestionFrqField(null, qIndex, 'choice_group', parseInt(e.target.value) || null)} />
                                                            </Box>
                                                            {(question.frq_type === 'saq' || question.frq_type === 'upload') && question.frq_parts && (
                                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
                                                                    <Typography variant="caption" color="text.secondary" sx={{ mr: 0.5 }}>Parts:</Typography>
                                                                    {question.frq_parts.map((part, pIdx) => (
                                                                        <Box key={pIdx} sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
                                                                            <Typography variant="caption" fontWeight="bold">{part.part_label})</Typography>
                                                                            <TextField size="small" type="number" value={part.max_points}
                                                                                sx={{ width: 50 }}
                                                                                inputProps={{ min: 0, style: { padding: '2px 6px', fontSize: '0.75rem' } }}
                                                                                onChange={(e) => {
                                                                                    const updated = [...question.frq_parts];
                                                                                    updated[pIdx] = { ...updated[pIdx], max_points: parseInt(e.target.value) || 0 };
                                                                                    updateFrqParts(null, qIndex, updated);
                                                                                }} />
                                                                            <Typography variant="caption" color="text.secondary">pt</Typography>
                                                                            <Typography variant="caption"
                                                                                onClick={() => {
                                                                                    const updated = [...question.frq_parts];
                                                                                    updated[pIdx] = { ...updated[pIdx], part_type: part.part_type === 'upload' ? 'text' : 'upload' };
                                                                                    updateFrqParts(null, qIndex, updated);
                                                                                }}
                                                                                sx={{ cursor: 'pointer', px: 0.5, borderRadius: 0.5, fontSize: '0.6rem',
                                                                                    backgroundColor: part.part_type === 'upload' ? '#e3f2fd' : 'transparent',
                                                                                    color: part.part_type === 'upload' ? '#1565c0' : 'text.secondary',
                                                                                    border: '1px solid', borderColor: part.part_type === 'upload' ? '#1565c0' : 'transparent',
                                                                                    '&:hover': { backgroundColor: '#e3f2fd' } }}>
                                                                                {part.part_type === 'upload' ? 'IMG' : 'TXT'}
                                                                            </Typography>
                                                                        </Box>
                                                                    ))}
                                                                    <Button size="small" sx={{ minWidth: 24, p: 0, fontSize: '0.7rem' }}
                                                                        onClick={() => {
                                                                            const nextLabel = String.fromCharCode(97 + question.frq_parts.length);
                                                                            updateFrqParts(null, qIndex, [...question.frq_parts, { part_label: nextLabel, max_points: 1 }]);
                                                                        }}>+</Button>
                                                                    {question.frq_parts.length > 1 && (
                                                                        <Button size="small" color="error" sx={{ minWidth: 24, p: 0, fontSize: '0.7rem' }}
                                                                            onClick={() => updateFrqParts(null, qIndex, question.frq_parts.slice(0, -1))}>−</Button>
                                                                    )}
                                                                </Box>
                                                            )}
                                                        </Box>
                                                    ) : (
                                                    <ul>
                                                        {(question.is_multi_select || question.isMultiSelect) ? (
                                                            <FormGroup row sx={{mb: 2}}>
                                                                {question?.question_options?.map((choice, cIndex) => (
                                                                    <FormControlLabel
                                                                        key={cIndex}
                                                                        control={
                                                                            <Checkbox
                                                                                checked={(question.answer || '').split(',').includes(choice.option)}
                                                                                onChange={() => handleSampleAnswerChange(qIndex, choice.option, true)}
                                                                            />
                                                                        }
                                                                        label={choice.option}
                                                                    />
                                                                ))}
                                                            </FormGroup>
                                                        ) : (
                                                            <RadioGroup
                                                                row
                                                                value={question.answer ? question.answer : ""}
                                                                onChange={(e) => handleSampleAnswerChange(qIndex, e.target.value)}
                                                                sx={{mb: 2}}
                                                            >
                                                                {question?.question_options?.map((choice, cIndex) => (
                                                                    <FormControlLabel key={cIndex} value={choice.option} control={<Radio />} label={choice.option} />
                                                                ))}
                                                            </RadioGroup>
                                                        )}
                                                    </ul>
                                                    )}
                                                </li>
                                            ))}
                                        </ul>
                                    </Box>
                                )
                            )}
                                </Box>
                            )}
                        </Box>
                    </Box>
                    {((numQuestions && numChoices) || selectedSectionIndex !== null) && (<>
                        <Box
                            sx={{
                                position: 'fixed',
                                top: '15%',
                                right: !previewCardToggle ? 40 : -200,
                                transform: 'translateY(-50%)',
                                zIndex: 101,
                                transition: 'right 0.5s',
                                minWidth: 400,
                                maxWidth: 550,
                            }}
                        >
                            <IconButton
                                onClick={() => setPreviewCardToggle(!previewCardToggle)}
                            >
                                {previewCardToggle ?
                                <h4>Show Preview</h4> : <h4>Hide</h4>
                                }
                                {previewCardToggle ?
                                <KeyboardDoubleArrowLeftIcon fontSize='large' /> :
                                <KeyboardDoubleArrowRightIcon fontSize='large' />}
                            </IconButton>
                        </Box>
                        <Box
                            sx={{
                                position: 'fixed',
                                top: '42%',
                                right: !previewCardToggle ? 40 : -350,
                                transform: 'translateY(-50%)',
                                backgroundColor: colors.primary[600],
                                border: `5px solid ${colors.grey[800]}`,
                                boxShadow: 10,
                                zIndex: 100,
                                padding: 2,
                                transition: 'right 0.5s',
                                height: "50%",
                                width: 400,
                                overflowX: 'hidden',
                                overflowY: 'auto',
                            }}
                        >
                            {((isSection?.value === "No Section" && sample?.length > 0 && selectedSectionIndex === 0) ||
                              (isSection?.value === "With Section" && sections.length > 0 && selectedSectionIndex !== null)) ? (
                                <>
                                    <QuestionPreviewForTest numChoices={previewNumChoices} setNumChoices={setPreviewNumChoices} setOptionName={setPreviewOptionName} optionName={previewOptionName} readOnlyNames={useActStyleChoices}/>
                                    <Typography variant="caption" sx={{ mt: 1, color: colors.grey[400], display: "block" }}>
                                        {useActStyleChoices
                                            ? "Choice labels are set automatically (A,B,C,D / F,G,H,J). You can add or remove choices."
                                            : isSection?.value === "No Section"
                                                ? "Changes here will automatically update the sample below."
                                                : `Changes here will update Section ${selectedSectionIndex + 1}.`
                                        }
                                    </Typography>
                                </>
                            ) : (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        height: '100%',
                                        color: colors.grey[400],
                                    }}
                                >
                                    <Typography variant="h6" textAlign="center">
                                        {isSection?.value === "No Section"
                                            ? "Create a sample to see preview"
                                            : "Select a section to see preview"
                                        }
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                    </>)}
                    
                    <Box
                        sx={{ 
                            display: "flex", 
                            flexDirection: "row", 
                            gap: "10px", 
                            mt: 2, 
                            p: 2, 
                            bgcolor: colors.primary[600], 
                            borderRadius: 2, 
                            boxShadow: 3 
                        }}
                    >
                        <FormControl>
                            <DragDropContext onDragEnd={handleDragEnd}>
                                <Droppable droppableId="sections" direction="horizontal" type="SECTION">
                                    {(provided, snapshot) => (
                                        <Box
                                            {...provided.droppableProps}
                                            ref={provided.innerRef}
                                            sx={{
                                                display: "flex", 
                                                // flexDirection: "row",
                                                flexWrap: "wrap", 
                                                gap: 2,
                                            }}
                                        >
                                            {isSection?.value === "With Section" && sections && sections.length > 0 && sections.map((section, sectionIndex) => (
                                                <Draggable key={sectionIndex} draggableId={`section-${sectionIndex}`} index={sectionIndex}>
                                                    {(provided, snapshot) => (
                                                        <Box
                                                            key={sectionIndex}
                                                            sx={{
                                                                minWidth: "400px",
                                                                maxWidth: "400px",
                                                                flex: '1 0 21%', // This ensures four items per row
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                justifyContent: "space-between",
                                                                alignItems: "flex-start",
                                                                p: 2,
                                                                bgcolor: colors.primary[700],
                                                                borderRadius: 2,
                                                                width: "100%",
                                                                boxShadow: 3,
                                                                mb: 2,
                                                                border: selectedSectionIndex === sectionIndex ? `3px solid ${colors.blueAccent[400]}` : "3px solid transparent",
                                                                cursor: "pointer",
                                                            }}
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            onClick={() => setSelectedSectionIndex(selectedSectionIndex === sectionIndex ? null : sectionIndex)}
                                                        >
                                                            <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                                                <Box>
                                                                    <TextField
                                                                        label="Section Name"
                                                                        variant="outlined"
                                                                        value={section.section_name ? section.section_name : ``}
                                                                        onChange={(e) => handleSectionNameChange(e, sectionIndex)}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    />
                                                                    <Typography variant="body1">{section.numQuestions} questions</Typography>
                                                                </Box>
                                                                {selectedSectionIndex === sectionIndex && (
                                                                    <Box
                                                                        sx={{
                                                                            bgcolor: colors.blueAccent[500],
                                                                            color: "white",
                                                                            px: 1,
                                                                            py: 0.25,
                                                                            borderRadius: 1,
                                                                            fontSize: "0.7rem",
                                                                            fontWeight: "bold",
                                                                            alignSelf: "flex-start",
                                                                        }}
                                                                    >
                                                                        Selected
                                                                    </Box>
                                                                )}
                                                                <ClearIcon
                                                                    fontSize='small'
                                                                    color='error'
                                                                    sx={{ cursor: "pointer" }}
                                                                    onClick={(e) => { e.stopPropagation(); handleClickDialogOpen(sectionIndex); }}
                                                                /> 
                                                            </Box>
                                                            <Box sx={{height: "100%"}} onClick={(e) => e.stopPropagation()}>
                                                                <ul>
                                                                    {section?.test_questions?.map((question, qIndex) => (
                                                                        <li key={qIndex}>
                                                                            <Box sx={{ display: "flex", flexDirection: "column"}}>
                                                                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                                                                    <Typography variant="body1">Q{question.question_number}</Typography>
                                                                                    <AddIcon
                                                                                        fontSize='small'
                                                                                        color='primary'
                                                                                        sx={{ cursor: "pointer", ml: 1, mr: 1 }}
                                                                                        onClick={() => handleAddQuestion(sectionIndex, qIndex, question.question_options)}
                                                                                    />
                                                                                    <RemoveIcon
                                                                                        fontSize='small'
                                                                                        color='primary'
                                                                                        sx={{ cursor: "pointer", mr: 1 }}
                                                                                        onClick={() => handleDeleteQuestion(sectionIndex, qIndex)}
                                                                                    />
                                                                                    <FormControl size="small" sx={{ minWidth: 80, ml: 1 }}>
                                                                                        <Select
                                                                                            value={question.question_type || 'mcq'}
                                                                                            onChange={(e) => handleQuestionTypeChange(sectionIndex, qIndex, e.target.value)}
                                                                                            sx={{ fontSize: '0.75rem', height: 28 }}
                                                                                        >
                                                                                            <MenuItem value="mcq">MCQ</MenuItem>
                                                                                            <MenuItem value="sa">SA</MenuItem>
                                                                                            <MenuItem value="frq">FRQ</MenuItem>
                                                                                        </Select>
                                                                                    </FormControl>
                                                                                    {(!question.question_type || question.question_type === 'mcq') && (
                                                                                        <FormControlLabel
                                                                                            control={
                                                                                                <Switch
                                                                                                    size="small"
                                                                                                    checked={question.is_multi_select || question.isMultiSelect || false}
                                                                                                    onChange={() => handleSectionMultiSelectToggle(sectionIndex, qIndex)}
                                                                                                />
                                                                                            }
                                                                                            label={<Typography variant="caption">Multi</Typography>}
                                                                                        />
                                                                                    )}
                                                                                </Box>
                                                                            </Box>
                                                                            {question.question_type === 'sa' ? (
                                                                                <Box sx={{ ml: 2, p: 1, border: '1px dashed #4cceac', borderRadius: 1 }}>
                                                                                    <Typography variant="caption" color="text.secondary">Accepted Answers (first = display answer):</Typography>
                                                                                    {(question.accepted_answers || ['']).map((alt, aIdx) => (
                                                                                        <Box key={aIdx} sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
                                                                                            <Typography variant="caption" sx={{ minWidth: 16, color: aIdx === 0 ? colors.greenAccent[400] : colors.grey[500] }}>{aIdx + 1}.</Typography>
                                                                                            <TextField size="small" value={alt}
                                                                                                placeholder={aIdx === 0 ? 'Primary answer' : `Alternate ${aIdx}`}
                                                                                                onChange={(e) => {
                                                                                                    const newAlts = [...(question.accepted_answers || [''])];
                                                                                                    newAlts[aIdx] = e.target.value;
                                                                                                    const updatedSections = sections.map((s, si) => si === sectionIndex ? { ...s, test_questions: s.test_questions.map((q, qi) => qi === qIndex ? { ...q, accepted_answers: newAlts, answer: newAlts[0] || '' } : q) } : s);
                                                                                                    setSections(updatedSections);
                                                                                                }}
                                                                                                sx={{ flex: 1 }}
                                                                                            />
                                                                                            {(question.accepted_answers || ['']).length > 1 && (
                                                                                                <IconButton size="small" onClick={() => {
                                                                                                    const newAlts = (question.accepted_answers || ['']).filter((_, i) => i !== aIdx);
                                                                                                    const updatedSections = sections.map((s, si) => si === sectionIndex ? { ...s, test_questions: s.test_questions.map((q, qi) => qi === qIndex ? { ...q, accepted_answers: newAlts, answer: newAlts[0] || '' } : q) } : s);
                                                                                                    setSections(updatedSections);
                                                                                                }}>
                                                                                                    <ClearIcon fontSize="small" />
                                                                                                </IconButton>
                                                                                            )}
                                                                                        </Box>
                                                                                    ))}
                                                                                    <Button size="small" onClick={() => {
                                                                                        const newAlts = [...(question.accepted_answers || ['']), ''];
                                                                                        const updatedSections = sections.map((s, si) => si === sectionIndex ? { ...s, test_questions: s.test_questions.map((q, qi) => qi === qIndex ? { ...q, accepted_answers: newAlts } : q) } : s);
                                                                                        setSections(updatedSections);
                                                                                    }}>+ Add</Button>
                                                                                </Box>
                                                                            ) : question.question_type === 'frq' ? (
                                                                                <Box sx={{ ml: 2, p: 1, border: '1px dashed #999', borderRadius: 1 }}>
                                                                                    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 1 }}>
                                                                                        <FormControl size="small" sx={{ minWidth: 120 }}>
                                                                                            <InputLabel>FRQ Type</InputLabel>
                                                                                            <Select value={question.frq_type || 'saq'} label="FRQ Type"
                                                                                                onChange={(e) => updateQuestionFrqField(sectionIndex, qIndex, 'frq_type', e.target.value)}>
                                                                                                <MenuItem value="saq">SAQ</MenuItem>
                                                                                                <MenuItem value="dbq">DBQ</MenuItem>
                                                                                                <MenuItem value="leq">LEQ</MenuItem>
                                                                                                <MenuItem value="upload">Upload</MenuItem>
                                                                                            </Select>
                                                                                        </FormControl>
                                                                                        {(() => {
                                                                                            const partsSum = question.frq_type === 'saq' && question.frq_parts
                                                                                                ? question.frq_parts.reduce((s, p) => s + (p.max_points || 0), 0) : null;
                                                                                            const mismatch = partsSum !== null && question.max_points !== partsSum;
                                                                                            return (
                                                                                                <TextField size="small" label="Max Points" type="number"
                                                                                                    value={question.max_points || ''} sx={{ width: 100 }}
                                                                                                    error={mismatch}
                                                                                                    helperText={mismatch ? `Parts sum: ${partsSum}` : ''}
                                                                                                    onChange={(e) => updateQuestionFrqField(sectionIndex, qIndex, 'max_points', parseInt(e.target.value) || 0)} />
                                                                                            );
                                                                                        })()}
                                                                                        <TextField size="small" label="Choice Group" type="number"
                                                                                            value={question.choice_group || ''} sx={{ width: 120 }}
                                                                                            onChange={(e) => updateQuestionFrqField(sectionIndex, qIndex, 'choice_group', parseInt(e.target.value) || null)} />
                                                                                    </Box>
                                                                                    {(question.frq_type === 'saq' || question.frq_type === 'upload') && question.frq_parts && (
                                                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
                                                                                            <Typography variant="caption" color="text.secondary" sx={{ mr: 0.5 }}>Parts:</Typography>
                                                                                            {question.frq_parts.map((part, pIdx) => (
                                                                                                <Box key={pIdx} sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
                                                                                                    <Typography variant="caption" fontWeight="bold">{part.part_label})</Typography>
                                                                                                    <TextField size="small" type="number" value={part.max_points}
                                                                                                        sx={{ width: 50 }}
                                                                                                        inputProps={{ min: 0, style: { padding: '2px 6px', fontSize: '0.75rem' } }}
                                                                                                        onChange={(e) => {
                                                                                                            const updated = [...question.frq_parts];
                                                                                                            updated[pIdx] = { ...updated[pIdx], max_points: parseInt(e.target.value) || 0 };
                                                                                                            updateFrqParts(sectionIndex, qIndex, updated);
                                                                                                        }} />
                                                                                                    <Typography variant="caption" color="text.secondary">pt</Typography>
                                                                                                    <Typography variant="caption"
                                                                                                        onClick={() => {
                                                                                                            const updated = [...question.frq_parts];
                                                                                                            updated[pIdx] = { ...updated[pIdx], part_type: part.part_type === 'upload' ? 'text' : 'upload' };
                                                                                                            updateFrqParts(sectionIndex, qIndex, updated);
                                                                                                        }}
                                                                                                        sx={{ cursor: 'pointer', px: 0.5, borderRadius: 0.5, fontSize: '0.6rem',
                                                                                                            backgroundColor: part.part_type === 'upload' ? '#e3f2fd' : 'transparent',
                                                                                                            color: part.part_type === 'upload' ? '#1565c0' : 'text.secondary',
                                                                                                            border: '1px solid', borderColor: part.part_type === 'upload' ? '#1565c0' : 'transparent',
                                                                                                            '&:hover': { backgroundColor: '#e3f2fd' } }}>
                                                                                                        {part.part_type === 'upload' ? 'IMG' : 'TXT'}
                                                                                                    </Typography>
                                                                                                </Box>
                                                                                            ))}
                                                                                            <Button size="small" sx={{ minWidth: 24, p: 0, fontSize: '0.7rem' }}
                                                                                                onClick={() => {
                                                                                                    const nextLabel = String.fromCharCode(97 + question.frq_parts.length);
                                                                                                    updateFrqParts(sectionIndex, qIndex, [...question.frq_parts, { part_label: nextLabel, max_points: 1 }]);
                                                                                                }}>+</Button>
                                                                                            {question.frq_parts.length > 1 && (
                                                                                                <Button size="small" color="error" sx={{ minWidth: 24, p: 0, fontSize: '0.7rem' }}
                                                                                                    onClick={() => updateFrqParts(sectionIndex, qIndex, question.frq_parts.slice(0, -1))}>−</Button>
                                                                                            )}
                                                                                        </Box>
                                                                                    )}
                                                                                </Box>
                                                                            ) : (
                                                                            <ul>
                                                                                {(question.is_multi_select || question.isMultiSelect) ? (
                                                                                    <FormGroup row sx={{mb: 2}}>
                                                                                        {question.question_options?.map((choice, cIndex) => (
                                                                                            <FormControlLabel
                                                                                                key={cIndex}
                                                                                                control={
                                                                                                    <Checkbox
                                                                                                        checked={(question.answer || '').split(',').includes(choice.option)}
                                                                                                        onChange={() => handleSectionAnswerChange(sectionIndex, qIndex, choice.option, true)}
                                                                                                    />
                                                                                                }
                                                                                                label={choice.option}
                                                                                            />
                                                                                        ))}
                                                                                    </FormGroup>
                                                                                ) : (
                                                                                    <RadioGroup
                                                                                        row
                                                                                        value={question.answer}
                                                                                        defaultValue={question.answer}
                                                                                        onChange={(e) => handleSectionAnswerChange(sectionIndex, qIndex, e.target.value)}
                                                                                        sx={{mb: 2}}
                                                                                    >
                                                                                        {question.question_options?.map((choice, cIndex) => (
                                                                                            <FormControlLabel key={cIndex} value={choice.option} control={<Radio />} label={choice.option} />
                                                                                        ))}
                                                                                    </RadioGroup>
                                                                                )}
                                                                            </ul>
                                                                            )}
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            </Box>
                                                        </Box>
                                                    )}
                                                </Draggable>
                                            ))}
                                            {provided.placeholder}
                                        </Box>
                                    )}
                                </Droppable>
                            </DragDropContext>
                        </FormControl>
                        
                        <Dialog
                            open={dialogOpen}
                            onClose={handleDialogClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">
                                {"Do you want to delete this section?"}
                            </DialogTitle>
                            <DialogActions>
                                <Button onClick={handleDeleteSection} color="warning" autoFocus>
                                    Yes
                                </Button>
                                <Button onClick={handleDialogClose}>No</Button>
                            </DialogActions>
                        </Dialog>
                    </Box>
                    
                    <Box display="flex" justifyContent="start" mt="20px" gap={2}>
                        <Button type="submit" color="secondary" variant="contained">
                            Update Test
                        </Button>
                        <Button
                            variant="outlined"
                            color="info"
                            startIcon={<VisibilityIcon />}
                            onClick={() => setPreviewDialogOpen(true)}
                        >
                            Student Preview
                        </Button>
                    </Box>
                </form>
                )}
            </Formik>
            <Alert
                successAlertOpen={successAlertOpen}
                setSuccessAlertOpen={setSuccessAlertOpen}
                errorAlertOpen={errorAlertOpen}
                setErrorAlertOpen={setErrorAlertOpen}
                successMsg={successAlertMessage}
                errorMsg={errorAlertMessage}
                vertical="bottom"
                horizontal="left"
            />
            <Backdrop backdropOpen={backdropOpen} handleBackdropClose={handleBackdropClose} />
            <HiddenPDF documentRender={documentRender} />
            <TestPreviewDialog
                open={previewDialogOpen}
                onClose={() => setPreviewDialogOpen(false)}
                hasSection={isSection?.value === "With Section"}
                sections={sections}
                sample={sample}
                testTitle={file?.name}
            />
        </Box>
    );
};

const checkoutSchema = yup.object().shape({
    questions: yup.number().required("required"),
    choices: yup.number().required("required"),
});

const initialValues = {
    questions: 0,
    choices: 0,
};

export default EditTest;
